 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED118 from '@/components/Untitled118'
 import UNTITLED119 from '@/components/Untitled119'
 import UNTITLED122 from '@/components/Untitled122'
 import UNTITLED123 from '@/components/Untitled123'
 import UNTITLED124 from '@/components/Untitled124'
 import UNTITLED125 from '@/components/Untitled125'
 import UNTITLED126 from '@/components/Untitled126'
 import UNTITLED127 from '@/components/Untitled127'
 import UNTITLED128 from '@/components/Untitled128'
 import UNTITLED129 from '@/components/Untitled129'
 import UNTITLED130 from '@/components/Untitled130'
 import UNTITLED131 from '@/components/Untitled131'
 import UNTITLED132 from '@/components/Untitled132'
 import UNTITLED133 from '@/components/Untitled133'
 import UNTITLED134 from '@/components/Untitled134'
 import UNTITLED135 from '@/components/Untitled135'
 import UNTITLED136 from '@/components/Untitled136'
 import UNTITLED137 from '@/components/Untitled137'
 import COPYRIGHT from '@/components/copyright'
 import UNTITLED138 from '@/components/Untitled138'
 import UNTITLED139 from '@/components/Untitled139'
 import LOVE_2 from '@/components/love_2'
 import DELPHINIUM from '@/components/delphinium'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled118",
 			"name" : "Untitled118",
 			"component" : UNTITLED118
 		},
 		{
 			"path" : "/Untitled119",
 			"name" : "Untitled119",
 			"component" : UNTITLED119
 		},
 		{
 			"path" : "/Untitled122",
 			"name" : "Untitled122",
 			"component" : UNTITLED122
 		},
 		{
 			"path" : "/Untitled123",
 			"name" : "Untitled123",
 			"component" : UNTITLED123
 		},
 		{
 			"path" : "/Untitled124",
 			"name" : "Untitled124",
 			"component" : UNTITLED124
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js